<template>
  <div>
    <!-- SEO Meta Tags -->
    <PageSEO
      title="Vedware - Professional Web Development & Digital Solutions"
      description="Expert web development services, modern applications, and digital solutions. 20+ years of experience delivering high-quality projects for businesses worldwide."
      :keywords="['web development', 'digital solutions', 'web applications', 'frontend development', 'backend development', 'full-stack development', 'portfolio']"
      url="https://vedware.com"
    />

    <AppBanner />
    <ServicesStrip />
    <AppsShowcase />

    <section class="py-20">
      <div class="container mx-auto">
        <div v-reveal class="mb-12 text-center">
          <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
            Selected <span class="bg-gradient-to-r from-accent to-gradient-end bg-clip-text text-transparent">work</span>
          </h2>
          <p class="text-lg text-gray-600 dark:text-gray-400">
            A few projects we built for clients and for ourselves
          </p>
        </div>

        <ProjectsGrid :projects="featuredProjects" :filterable="false" />

        <div class="mt-12 flex justify-center sm:mt-16">
          <Btn to="/projects" class="group bg-gradient-to-r from-accent to-gradient-end transition-all duration-300 hover:shadow-glow">
            All Projects
            <PhArrowRight class="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Btn>
        </div>
      </div>
    </section>

    <ProcessRow />

    <ServiceCTA
      title="Have a project in"
      highlighted-title="mind?"
      description="Tell us what you want to build and we will get back to you within 24 hours."
      secondary-button-text="Explore Services"
    />
  </div>
</template>

<script setup lang="ts">
import { PhArrowRight } from '@phosphor-icons/vue'
import AppBanner from '~/components/Layout/AppBanner.vue'
import ProjectsGrid from '~/components/Projects/ProjectsGrid.vue'
import AppsShowcase from '~/components/Sections/AppsShowcase.vue'
import ProcessRow from '~/components/Sections/ProcessRow.vue'
import ServicesStrip from '~/components/Sections/ServicesStrip.vue'
import ServiceCTA from '~/components/Services/ServiceCTA.vue'
import PageSEO from '~/components/Shared/PageSEO.vue'
import Btn from '~/components/UI/Btn.vue'
import { findProject } from '~/utils/projects'

const featuredSlugs = ['tasktribe', 'tripexpert', 'mentas-wordpress']
const featuredProjects = featuredSlugs.map(slug => findProject(slug)).filter(project => !!project)
</script>
